// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"9fcd3a84","250":"3b53517f","327":"3b53517f","375":"3b53517f"}[chunkId] + ".chunk.css";
};